export const getAttendanceEntryList = state => {
    return state.list
}

export const getAttendanceEntryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/attendanceEntry/getters.js